<template>
  <v-dialog
    :value="isPartnerPopupOpen"
    :max-width="$isMobile ? 360 : 700"
    persistent
    no-click-animation
    @keydown.esc="closePopup"
  >
    <PartnerPopupCard
      v-if="popup"
      :heading="popup.heading"
      :subheading="popup.subheading"
      :body="popup.body"
      :cta-label="popup.cta_label"
      :image="image"
      :show-trusted-partner="popup.show_trusted_partner"
      :mobile="$isMobile"
      data-qa="partner-popup"
      @close="closePopup"
      @cta="followCta"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PartnerPopupCard from './PartnerPopupCard.vue';

export default {
  name: 'PartnerPopupDialog',

  components: { PartnerPopupCard },

  computed: {
    ...mapState('partnerPopup', ['popup']),
    ...mapGetters('partnerPopup', ['isPartnerPopupOpen']),

    image() {
      if (!this.popup) return '';
      if (this.$isMobile) return this.popup.image_mobile || this.popup.image_desktop;
      return this.popup.image_desktop;
    },
  },

  watch: {
    isPartnerPopupOpen(open) {
      if (open) this.recordView();
    },
  },

  mounted() {
    this.loadActivePopup();
  },

  methods: {
    ...mapActions('partnerPopup', ['loadActivePopup', 'recordView', 'recordCtaClick', 'closePopup']),

    async followCta() {
      const { cta_url: ctaUrl } = this.popup;
      await this.recordCtaClick();
      this.closePopup();

      if (!ctaUrl) return;
      if (ctaUrl.startsWith('/')) {
        this.$router.push(ctaUrl).catch(() => {});
      } else {
        window.open(ctaUrl, '_blank', 'noopener');
      }
    },
  },
};
</script>
